import { render, staticRenderFns } from "./amz_import.vue?vue&type=template&id=38335b14&"
import script from "./amz_import.vue?vue&type=script&lang=js&"
export * from "./amz_import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports